import { useQuery, useMutation } from "react-query"
import { fetchGET2 } from "utils/https/https"

// To get the data at Multiplicator
export const UseQueryMultplicatorGoalsCommissions = (data: any) => {
  const username = data?.username ? data?.username : null
  const year = data?.year && data?.year.length > 0 ? data?.year[0] : null
  const month = data?.month && data?.month.length > 0 ? data?.month[0] : null
  const initialDate = data?.initialDatePeriod && data?.initialDatePeriod.length > 0 ? data?.initialDatePeriod[0] : null
  const endDate = data?.endDatePeriod && data?.endDatePeriod.length > 0 ? data?.endDatePeriod[0] : null

  const pageNumber = data?.pageNumber
  const pageSize = data?.pageSize
  const sortOrder = data?.sortOrder ? data.sortOrder : null
  const sortField = data?.sortField ? data.sortField : null

  return useQuery(['UseQueryMultplicatorGoalsCommissions', username, year, month, initialDate, endDate, pageNumber, pageSize, sortOrder, sortField], async () => {
    try {
      const serchParms = new URLSearchParams();

      if (username) {
        serchParms.append('username', username)
      }

      if (year) {
        serchParms.append('year', year)
      }

      if (month) {
        serchParms.append('month', month)
      }

      if (initialDate) {
        serchParms.append('initialDate', initialDate)
      }

      if (endDate) {
        serchParms.append('endDate', endDate)
      }

      if (pageNumber) {
        serchParms.append('pageNumber', pageNumber)
      }

      if (pageSize) {
        serchParms.append('rowsPerPage', pageSize)
      }

      if (sortOrder) {
        serchParms.append('sortOrder', sortOrder)
      }

      if (sortField) {
        serchParms.append('sortField', sortField)
      }

      const response = await fetchGET2(`Multiplier/ListMultipliers?&${serchParms.toString()}`)
      return response
    } catch (error) {
      throw error
    }
  })
}


// This is the request to download the file according to the params at multipliers and goals
const UseDownloadMultplierCommission = async (data: any) => {
  const username = data?.username ? data?.username : null
  const year = data?.year && data?.year.length > 0 ? data?.year[0] : null
  const month = data?.month && data?.month.length > 0 ? data?.month[0] : null
  const initialDate = data?.initialDatePeriod && data?.initialDatePeriod.length > 0 ? data?.initialDatePeriod[0] : null
  const endDate = data?.endDatePeriod && data?.endDatePeriod.length > 0 ? data?.endDatePeriod[0] : null

  const pageNumber = data?.pageNumber
  const pageSize = data?.pageSize
  const sortOrder = data?.sortOrder ? data.sortOrder : null
  const sortField = data?.sortField ? data.sortField : null

  try {
    const serchParms = new URLSearchParams();

    if (username) {
      serchParms.append('username', username)
    }

    if (year) {
      serchParms.append('year', year)
    }

    if (month) {
      serchParms.append('month', month)
    }

    if (initialDate) {
      serchParms.append('initialDate', initialDate)
    }

    if (endDate) {
      serchParms.append('endDate', endDate)
    }


    if (pageNumber) {
      serchParms.append('pageNumber', pageNumber)
    }

    if (pageSize) {
      serchParms.append('rowsPerPage', pageSize)
    }

    if (sortOrder) {
      serchParms.append('sortOrder', sortOrder)
    }

    if (sortField) {
      serchParms.append('sortField', sortField)
    }

    const response = await fetchGET2(`Multiplier/DownloadMultipliers?&${serchParms.toString()}`, { responseType: 'blob' })
    const href = URL.createObjectURL(response.data);

    const link = document.createElement('a');
    link.href = href;
    link.setAttribute('download', 'multiplierKam.xlsx');
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    URL.revokeObjectURL(href);


    return response
  } catch (error) {
    throw error
  }

}


export const UseDownloadMultipliersCommission = (callbackSuccess: any) => {
  return useMutation(UseDownloadMultplierCommission, {
    onSuccess: (data) => {
      callbackSuccess(data);
    },
  });
};
